import { s as makeRestApiRequest } from "./utils2.mjs";

//#region src/api/roles.ts
const getRoles = async (context) => {
	return await makeRestApiRequest(context, "GET", "/roles?withUsageCount=true");
};
const createProjectRole = async (context, body) => {
	return await makeRestApiRequest(context, "POST", "/roles", body);
};
const getRoleBySlug = async (context, body) => {
	return await makeRestApiRequest(context, "GET", `/roles/${body.slug}?withUsageCount=true`);
};
const updateProjectRole = async (context, slug, body) => {
	return await makeRestApiRequest(context, "PATCH", `/roles/${slug}`, body);
};
const deleteProjectRole = async (context, slug) => {
	return await makeRestApiRequest(context, "DELETE", `/roles/${slug}`);
};

//#endregion
export { updateProjectRole as a, getRoles as i, deleteProjectRole as n, getRoleBySlug as r, createProjectRole as t };
//# sourceMappingURL=roles.mjs.map